<ion-card *ngIf="billingInfo$ | async as info">
  <ion-card-header>
    <ion-card-title>{{ info.title }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <p>{{ info.message }}</p>
  </ion-card-content>
  <ion-button
    class="ion-margin-horizontal ion-margin-bottom"
    expand="block"
    fill="outline"
    color="secondary"
    (click)="onAction()"
  >
    {{ info.buttonText }}
  </ion-button>
</ion-card>
